export function getCmsFormBuilderId(name: string) {
  return `form-builder-${name}`;
}
